export const getArrayWithItemDeleted = (items: any[], index: number) => {
  if (items.length === 0) return items;
  const itemsCopy = [...items];
  itemsCopy.splice(index, 1);
  return itemsCopy;
};
